import { FC } from 'react';

import { usePage } from '@inertiajs/react';
import { TrendingUp } from 'lucide-react';

import { ProductCardLink } from './ProductCardLink';
import { CartonProduct, ProductType, Expansion } from '../../types';

type PageProps = {
    bestSellers: CartonProduct[];
    currentProductType: ProductType;
    currentExpansion: Expansion;
};

export const Bestsellers: FC = () => {
    const { bestSellers, currentProductType, currentExpansion } =
        usePage<PageProps>().props;

    if (currentProductType || currentExpansion) {
        return null;
    }

    return (
        <section className="border-b bg-muted/30 py-4 pb-8">
            <div className="container px-4">
                <div className="mb-4 flex items-center justify-between">
                    <h2 className="flex items-center gap-2 text-lg font-bold md:text-xl">
                        <TrendingUp className="h-5 w-5 text-primary" />В тренді
                    </h2>
                </div>

                <div
                    className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4 lg:grid-cols-5 2xl:grid-cols-6"
                    data-testid="bestsellers-grid"
                >
                    {bestSellers &&
                        bestSellers.map((product, index) => (
                            <div
                                key={product.id}
                                className={
                                    index < 4
                                        ? ''
                                        : index === 4
                                          ? 'md:hidden lg:block'
                                          : index === 5
                                            ? 'md:hidden 2xl:block'
                                            : 'md:hidden'
                                }
                            >
                                <ProductCardLink
                                    product={product}
                                    loading={false}
                                    eagerLoadImage={true}
                                />
                            </div>
                        ))}
                </div>
            </div>
        </section>
    );
};
